module.exports = __webpack_public_path__ + "static/drainlaying_2_thumb-8d59c09c103d54587b7d5f7c41188d01.jpg";